var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_770",
    "data-name": "Group 770",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.296,
    height: 20.296,
    viewBox: "0 0 20.296 20.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_monitor",
    "data-name": "vuesax/bold/monitor",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.159,0H3.729A3.736,3.736,0,0,0,0,3.729V9.4a3.73,3.73,0,0,0,3.729,3.729H6.977a.848.848,0,0,1,.846.846v.82a.848.848,0,0,1-.846.846H4.93a.639.639,0,0,0,0,1.277h7.061a.634.634,0,0,0,0-1.269H9.945A.848.848,0,0,1,9.1,14.8v-.82a.848.848,0,0,1,.846-.846h3.222A3.73,3.73,0,0,0,16.9,9.4V3.738A3.75,3.75,0,0,0,13.159,0Z",
    transform: "translate(1.691 1.691)",
    fill: "#5a607f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H20.3V20.3H0Z",
    transform: "translate(20.296 20.296) rotate(180)",
    fill: "none",
    opacity: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(7.611 5.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    d: "M300.8,417.673a.934.934,0,0,1-.776.283h-.768l-.866-.04-.021-.952V416.3a.929.929,0,0,1,.283-.776,1.065,1.065,0,0,1,.957-.041,1.866,1.866,0,0,1,1.236,1.236A1.03,1.03,0,0,1,300.8,417.673Z",
    transform: "translate(-295.618 -415.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    d: "M299.726,418.853a2.337,2.337,0,0,1-.944,1.583,2.31,2.31,0,0,1-2.713,0,2.308,2.308,0,0,1-.513-3.224,2.335,2.335,0,0,1,1.583-.944.359.359,0,0,1,.286.088.364.364,0,0,1,.126.276v1.81h1.81a.368.368,0,0,1,.275.126A.361.361,0,0,1,299.726,418.853Z",
    transform: "translate(-295.117 -415.529)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.4e3268bebb0ccb9de7dd9a11c7ca469f.svg";
export { ForwardRef as ReactComponent };